import React, { useState, useEffect } from 'react';
import axios from 'axios';
import baseURL from './baseURl';

const ConvertPage = () => {
  const [data, setData] = useState([]); // Transactions to convert
  const [convertedData, setConvertedData] = useState([]); // Converted transactions
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [langdiWeight, setLangdiWeight] = useState('');
  const [touch, setTouch] = useState('');
  const [transactionId, setTransactionId] = useState(null);
  const [viewTransaction, setViewTransaction] = useState(null);

  // Fetch transactions from the API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${baseURL}/api/transactions`);
        console.log('Fetched data:', response.data);

        // Filter transactions for 'langdiWeight' with 'not converted' status
        const filteredData = response.data.filter(transaction =>
          transaction.articleType === 'langdiWeight' && transaction.status === 'not converted'
        );
        console.log('Filtered Transactions Data:', filteredData);
        setData(filteredData);
      } catch (err) {
        console.error('Error fetching data:', err);
        setError('Error fetching data');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Fetch converted transactions
  useEffect(() => {
    const fetchConvertedTransactions = async () => {
      try {
        const response = await axios.get(`${baseURL}/api/conversions/converted-transactions`);
        console.log('Fetched converted transactions:', response.data);
        setConvertedData(response.data);
      } catch (err) {
        console.error('Error fetching converted transactions:', err);
      }
    };
    fetchConvertedTransactions();
  }, []);

  // Handle conversion submission
  const handleConvert = async (e) => {
    e.preventDefault();
    if (!transactionId) return; // Check if transactionId is set

    // Prepare data for conversion
    const conversionData = {
      langdiWeight,
      touch,
      transactionId,
    };

    console.log('Conversion data being sent:', conversionData);

    try {
      const response = await axios.post(`${baseURL}/api/conversions/log-conversion`, conversionData);
      console.log('Converted transaction data:', response.data);
       
      alert('Conversion successful!');

      // Update data with the converted transaction
      setData((prevData) =>
        prevData.map((transaction) =>
          transaction._id === transactionId ? { ...transaction, ...response.data } : transaction
        )
      );

      // Reset form inputs
      setTransactionId(null);
      setLangdiWeight('');
      setTouch('');
    } catch (error) {
      console.error('Error converting langdi to pure:', error);
      alert('Conversion failed. Please try again.');
      if (error.response) {
        console.error('Error response data:', error.response.data);
        console.error('Error response status:', error.response.status);
      }
    }
  };

  // Handle viewing transaction details
  const handleView = async (id) => {
    try {
      const response = await axios.get(`${baseURL}/api/conversions/converted-transactions/${id}`);
      setViewTransaction(response.data);
    } catch (error) {
      console.error('Error fetching transaction details:', error);
      alert('Failed to fetch transaction details.');
    }
  };

  // Helper function to safely format numbers
  const formatNumber = (value, defaultValue = '0.00') => {
    return typeof value === 'number' ? value.toFixed(2) : defaultValue;
  };

  // Function to format date as "DD/MM/YYYY"
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date)) {
      console.error('Invalid date:', dateString);
      return 'Invalid Date';
    }
    return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
  };

  return (
    <div className="container mt-4">
      <h1 className="text-center mb-4">Conversion Data</h1>

      {loading && (
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      {error && <p className="text-danger text-center">{error}</p>}

      {!loading && !error && data.length > 0 ? (
        <div>
          <div className="table-responsive">
            <table className="table table-striped table-bordered">
              <thead className="table-dark">
                <tr>
                  <th>Date</th>
                  <th>Client Name</th>
                  <th>Langdi Weight (gms)</th>
                  <th>Touch</th>
                  <th>Receipt No</th>
                  <th>Pure Weight (gms)</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {data.map((transaction) => (
                  <tr key={transaction._id}>
                    <td>{formatDate(transaction.date)}</td>
                    <td>{transaction.clientName}</td>
                    <td>{formatNumber(transaction.langdiWeight)} gms</td>
                    <td>{formatNumber(transaction.touch, 'N/A')}</td>
                    <td>{transaction.receiptNo}</td>
                    <td>{formatNumber(transaction.pureWeight)} gms</td>
                    <td>
                      {transaction.status === 'not converted' ? (
                        <>
                          {transactionId === transaction._id ? (
                            <form className="d-flex" onSubmit={handleConvert}>
                              <input
                                type="number"
                                className="form-control me-2"
                                placeholder="Langdi Weight"
                                style={{ width: '150px' }}
                                value={langdiWeight}
                                onChange={(e) => setLangdiWeight(e.target.value)}
                                required
                              />
                              <input
                                type="number"
                                className="form-control me-2"
                                placeholder="Touch"
                                style={{ width: '150px' }}
                                value={touch}
                                onChange={(e) => setTouch(e.target.value)}
                                required
                              />
                              <button type="submit" className="btn btn-success me-2">
                                Submit
                              </button>
                              <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => setTransactionId(null)}
                              >
                                Cancel
                              </button>
                            </form>
                          ) : (
                            <button
                              className="btn btn-primary"
                              onClick={() => setTransactionId(transaction._id)}
                            >
                              Convert
                            </button>
                          )}
                        </>
                      ) : (
                        <span className="text-success">Already Converted</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {viewTransaction && (
            <div className="mt-4">
              <h3>Transaction Details</h3>
              <p><strong>Date:</strong> {formatDate(viewTransaction.transactionDate)}</p>
              <p><strong>Client Name:</strong> {viewTransaction.clientName}</p>
              <p><strong>Langdi Weight:</strong> {formatNumber(viewTransaction.langdiWeight)} gms</p>
              <p><strong>Touch:</strong> {formatNumber(viewTransaction.touch, 'N/A')}</p>
              <p><strong>Receipt No:</strong> {viewTransaction.receiptNo}</p>
              <p><strong>Pure Weight:</strong> {formatNumber(viewTransaction.pureWeight)} gms</p>
              <p><strong>Status:</strong> {viewTransaction.status}</p>
              <button className="btn btn-secondary" onClick={() => setViewTransaction(null)}>
                Close
              </button>
            </div>
          )}

          {/* Section for displaying converted transactions */}
          <div className="mt-5">
            <h2 className="text-center">Converted Transactions</h2>
            {convertedData.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-striped table-bordered">
                  <thead className="table-dark">
                    <tr>
                      <th>Date</th>
                      <th>Client Name</th>
                      <th>Langdi Weight (gms)</th>
                      <th>Touch</th>
                      <th>Receipt No</th>
                      <th>Pure Weight (gms)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {convertedData.map((transaction) => (
                      <tr key={transaction._id}>
                        <td>{formatDate(transaction.date)}</td>
                        <td>{transaction.clientName}</td>
                        <td>{formatNumber(transaction.weight)} gms</td>
                        <td>{formatNumber(transaction.touch, 'N/A')}</td>
                        <td>{transaction.receiptNo}</td>
                        <td>{formatNumber(transaction.pureWeight)} gms</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="text-center">No converted transactions found.</p>
            )}
          </div>
        </div>
      ) : (
        <p className="text-center">No transactions available.</p>
      )}
    </div>
  );
};

export default ConvertPage;
